import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const FaqComponent = ({faq}) => {
  return (
    <div>
      {faq.map((faq, index) => (
        <Accordion
          key={index}
          disableGutters
          sx={{
            mb: 1.5,
            borderRadius: '15px !important',
            overflow: 'hidden',
            border: '1px solid #dfe9f1',
            boxShadow: '0 6px 18px rgba(24, 66, 101, .06)',
            '&::before': { display: 'none' },
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: '#1878bd' }} />}
            aria-controls={`faq-${index}-content`}
            id={`faq-${index}-header`}
            sx={{
              px: { xs: 2, md: 2.5 },
              py: .5,
              bgcolor: '#fff',
              '& .MuiAccordionSummary-content': { my: 1.4 },
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Assistant',
                fontWeight: 700,
                fontSize: { xs: '1rem', md: '1.08rem' },
                color: '#294f6d',
              }}
            >
              {faq.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              px: { xs: 2, md: 2.5 },
              pt: 1.5,
              pb: 2.2,
              bgcolor: '#fbfdff',
              borderTop: '1px solid #edf2f6',
            }}
          >
            <Typography sx={{ fontFamily: 'Assistant', lineHeight: 1.75, color: '#526c80' }}>
              {faq.answer}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
};

export default FaqComponent;
